module.exports = __webpack_public_path__ + "static/img/69.c4a227f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/69.jpg
// module id = wSbN
// module chunks = 0